<template>
    <div class="vm-dropdown" v-click-outside="close" :class="browser_size">
        <div ref="inner" class="show-area flex-box flex-align-items-center flex-justify-content-space-between nowrap" @click="tab" :style="{maxWidth:`${max_width}px`}">
            <span>{{cur_name || placeholder}}</span>
            <i class="afd ml10" :class="is_show_list ? 'afd-arrow-up' : 'afd-arrow-down'"></i>
        </div>
        <div class="list-box nowrap" :class="{right: is_right}" ref="list" v-show="is_show_list">
            <template v-for="(item,i) in options">
                <div class="item" v-if="item[track_key]" :key="i" @click="tap(item[track_value], i)">{{ item.name}}</div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'dropdown',
    props: {
        options: {
            default() {
                return [];
            },
        },
        placeholder:{
            default() {
                return this.$t('c.Dropdown.text1');
            },
        },
        value:{
            default() {
                return '';
            },
        },
        track_key:{
            default() {
                return 'name';
            },
        },
        track_value:{
            default() {
                return 'value';
            },
        },
        // max_width:{
        //     default() {
        //         return '';
        //     },
        // },
        is_auto_width:{
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            v: this.value,
            is_show_list:false,
            is_right:false,
            max_width:'',
        };
    },
    watch:{
        value(v){
            this.v = v;
        },
        is_show_list(v){
            this.$nextTick(() => {
                if(v){
                    let o = this.$refs.list.getBoundingClientRect()
                    if(o && o.width + o.left > document.body.clientWidth){
                        this.is_right = true
                    }
                }else{
                    this.is_right = false
                }
            })

        }
    },
    computed:{
        ...mapState('app', ['session_user','browser_size']),
        cur_name(){
            let arr = this.options.filter( v => v[this.track_value] === this.v)
            return arr && arr.length > 0 ? (arr[0].name2 || arr[0].name) : ''
        },
    },
    mounted() {
        if(this.is_auto_width){
            let ele = this.$refs.inner;
            let o = ele.getBoundingClientRect()
            let l = parseInt(window.getComputedStyle(ele, null)['padding-left'])
            let r = parseInt(window.getComputedStyle(ele, null)['padding-right'])
            this.max_width = o.width - l - r;
        }
    },
    methods: {
        tab(){
            this.is_show_list = !this.is_show_list;
        },
        tap(v, i){
            this.is_show_list = false;
            this.v = v;
            this.$emit('update:value', this.v) //变化了才触发
            this.$emit('dropdown_tap', {v:v,i:i}) //点击就触发
        },
        close(){
            this.is_show_list = false;
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-dropdown{
    border: 1px solid $black-1;
    border-radius: 4px;
    color:$black-8;
    font-size:14px;
    position: relative;
    .show-area{
        padding:12px 16px;
        cursor:pointer;
        overflow:hidden;
        box-sizing: border-box;
    }
    .list-box{
        position: absolute;
        background $white;
        left:-1px;
        right:-1px;
        bottom:0;
        max-height:200px;
        max-width:250px;
        overflow-y:scroll;
        transform: translateY(100%);
        border: 1px solid $black-1;
        box-shadow:$layer-shadow;
        z-index:1;
        .item{
            padding:8px;
            // min-width: 100px;
            &:hover{
                background $black-05;
                cursor:pointer;
            }
        }
        &.right{
            left:auto;
            right:0;
        }
    }
    &.small{
        .show-area{
            padding:4px 8px;
            cursor:pointer;
        }
    }
}
</style>
